import { MemoryRouter, Router, Switch, Route } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import GameContext from './context/game.context';
import TopicSelector from './components/TopicSelector/TopicSelector';
import Question from './components/Question/Question';
import Results from './components/Results/Results';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
// import Footer from './components/Footer/Footer';

// DEBUG: Use normal router to make debugging easier, use MemoryRouter in production
// import history from './util/history.util';

function App() {
    return (
        // <Router history={history}>
        <MemoryRouter>
            <ScrollToTop>
                <GameContext>
                    <div className='bg'></div>
                    <Container id="main-container">
                        <Row className="justify-content-center">
                            <Switch>
                                <Route
                                    path="/"
                                    exact
                                    component={TopicSelector}
                                />
                                <Route
                                    path="/topic/:topic/results"
                                    exact
                                    render={(props) => <Results {...props} />}
                                />
                                <Route
                                    path="/topic/:topic/:question"
                                    exact
                                    render={(props) => <Question {...props} key={props.match.params.question} />}
                                />
                            </Switch>
                        </Row>
                        {/* <Footer /> */}
                    </Container>
                </GameContext>
            </ScrollToTop>
        </MemoryRouter>
        // </Router>
    );
}

export default App;
